import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useContext } from 'react'
import './footer.css'
import { addcontext } from '../ContextShare/ContextShare';
function Footer() {
    const { ContactOpened, setContactOpened } = useContext(addcontext);
    const handleScrollUp = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      const handleContact=()=>{
        handleScrollUp()
        setContactOpened(true)
      }
  return (
    <div className='w-full h-32 bg-black flex justify-center gap-5 items-center px-10' style={{ fontFamily: 'Ropa Sans' }}>

      <div className='text-gray-200 flex items-center'>
        <Icon style={{ fontSize: 18, marginRight: 5 }} icon="ph:copyright-light" />
        <span>2024 | ADIL</span>
      </div>
<div className='w-0.5 h-6 bg-gray-700'></div>
      <div className='text-gray-200'>
       <button className='bg-gray-950 px-4 border rounded-full' onClick={handleContact}>Contact me</button>
      </div>
      <div className='text-gray-200 absolute right-5 rounded-full p-2 border' onClick={handleScrollUp}><Icon icon="fa6-solid:up-long" className='arrowup'/></div>

    </div>
  )
}

export default Footer
